/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { DataTable, DataTableRowToggleEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import CalendarDateSelector from "../CalendarDateSelector";
import { convertUTCEpochToDate } from "../../../../helper/DateConverters";
import { tableHeaderTemplate } from "../../Work Time Log Management/common/TimeLogTemplates";
import { fetchAllPreUseEquipmentCheckForm } from "./fetchData";

const PreUseEquipmentCheckListListing: React.FC = () => {
  const [expandedRows, setExpandedRows] = useState<any>([]);
  const [preUseEquipmentCheckForm, setPreUseEquipmentCheckForm] = useState<any>(
    []
  );
  const [preUseEquipmentCheckFormLoading, setPreUseEquipmentCheckFormLoading] =
    useState<boolean>(false);

  const [filters, setFilters] = useState<any>({
    startDate: null,
    endDate: null,
  });
  const toast = useRef<Toast>(null);

  const [sortFilter, setSortFilter] = useState<any>({
    sortField: "formDate",
    sortOrder: true,
  });

  const navigation = useNavigate();

  useEffect(() => {
    if (filters.startDate && filters.endDate) {
      fetchAllPreUseEquipmentCheckForm(
        setPreUseEquipmentCheckForm,
        setPreUseEquipmentCheckFormLoading,
        filters,
        toast
      );
    }
  }, [filters?.startDate, filters.endDate]);

  useEffect(() => {
    if (preUseEquipmentCheckForm.length > 0) {
      setExpandedRows([preUseEquipmentCheckForm[0]]); // Set the first row as expanded
    }
  }, [preUseEquipmentCheckForm]);

  const preUseEquipmentCheckFormBodyTemplate = (rowData: any) => {
    return (
      <div className="tw-flex tw-items-center tw-gap-2 hover:tw-bg-[#E8F9FF] tw-p-2 tw-cursor-pointer">
        <div className="tw-text-gray-700 tw-text-base tw-font-semibold tw-cursor-pointer">
          {rowData.formJson.site || "N/A"}
        </div>
      </div>
    );
  };

  const completedByBodyTemplate = (rowData: any) => {
    return (
      <div className="tw-text-gray-700 tw-text-sm tw-font-medium">
        {rowData?.formJson?.completedBy?.displayName || ""}
      </div>
    );
  };
  const navigate = useNavigate();

  // Custom error template (can also include icons or custom components)
  const emptyMessageTemplate = (
    <div style={{ textAlign: "center", fontSize: "1.25rem" }}>
      <h4>No records found.</h4>
    </div>
  );

  return (
    <>
      <Toast ref={toast} />
      <div className=" tw-bg-[#F8FAFC] tw-border-solid tw-border tw-border-[#E2E8F0] tw-rounded-lg">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-4 tw-p-4 tw-gap-2 tw-flex-wrap">
          <h2 className="tw-text-xl tw-font-semibold">
            Pre Use Equipment Check Listing
          </h2>
          <div className="tw-flex tw-gap-2 tw-items-center tw-justify-end tw-flex-wrap">
            <CalendarDateSelector setDateRange={setFilters} />
            <Button
              className="tw-flex tw-px-3 tw-py-2 tw-rounded bg-primary border-primary tw-text-white tw-font-medium"
              label="Add"
              icon="pi pi-plus"
              onClick={() =>
                navigate(`/layout/health-and-safety/add-equipment-checklist`)
              }
            />
          </div>
        </div>
        {preUseEquipmentCheckFormLoading ? (
          <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
            <ProgressSpinner />
          </div>
        ) : (
          <DataTable
            value={preUseEquipmentCheckForm}
            emptyMessage={emptyMessageTemplate}
            rowGroupMode="subheader"
            groupRowsBy="formDate"
            expandableRowGroups
            expandedRows={expandedRows}
            onRowToggle={(e: DataTableRowToggleEvent) => {
              setExpandedRows(e.data);
            }}
            tableStyle={{ minWidth: "50rem" }}
            rowGroupHeaderTemplate={(data: any) => {
              return (
                <div className="tw-inline-flex tw-justify-between tw-items-center tw-gap-3 table-row-group-header tw-bg-[#F8FAFC] tw-pl-2 tw-tex tw-font-semibold tw-text-base tw-text-[#64748B]">
                  {convertUTCEpochToDate(data.formDate)}
                </div>
              );
            }}
            onRowClick={(e) => {
              const rowData = e.data;
              navigation(
                `/layout/health-and-safety/view-equipment-checklist?formID=${rowData.id}`
              );
            }}
            rowClassName={() =>
              "hover:tw-bg-[#E8F9FF] tw-cursor-pointer tw-text-[#64748B]"
            }
            className="a-table timelog-datatable tw-text-nowrap tw-text-sm tw-text-[#64748B]"
            style={{ backgroundColor: "#000 !important" }}
          >
            <Column
              field="site"
              header={tableHeaderTemplate("Site", "", setSortFilter)}
              body={preUseEquipmentCheckFormBodyTemplate}
            />
            <Column
              field="completedBy"
              header={tableHeaderTemplate("Completed By", "", setSortFilter)}
              body={completedByBodyTemplate}
            />
            <Column
              field="Created On"
              header={tableHeaderTemplate("Created On", "", setSortFilter)}
              body={(rowData) => {
                return (
                  <div className="tw-text-gray-700 tw-text-sm tw-font-medium">
                    <span className="">
                      {new Date(rowData.createdDate).toLocaleTimeString(
                        "en-EN",
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        }
                      )}
                    </span>
                  </div>
                );
              }}
            />
          </DataTable>
        )}
      </div>
    </>
  );
};

export default PreUseEquipmentCheckListListing;
